.codePanel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}

.qrWrap {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  padding: 0.75rem;
  background: #ffffff;
}

.code {
  font-family: var(--font-mono);
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  margin: 0;
}

.deepLink {
  color: var(--teal-600);
  font-weight: 600;
}

.status {
  color: var(--muted);
  font-size: var(--text-min-body);
  margin: 0;
}
